import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { UpdateCarrierAreaContactActions } from 'store/ducks/settings/carrier-area-contact';

export function* updateCarrierAreaContactRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/carrier/contacts/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateCarrierAreaContactActions.success(data));
    notify('success', 'Contato atualizado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(UpdateCarrierAreaContactActions.failure(errorMessage));
  }
}
